package org.maplibre.compose.util

import org.maplibre.spatialk.geojson.Position

/**
 * Four-sided polygon representing the visible area of the map composable. If the camera is pitched,
 * this polygon is a trapezoid instead of a rectangle.
 *
 * Longitudes preserve the visible world copy and may extend past ±180°. A viewport wider than one
 * world can span more than 360° of longitude.
 */
public data class VisibleRegion
internal constructor(
  /** Position corresponding to the top-left corner of the map composable */
  val farLeft: Position,
  /** Position corresponding to the top-right corner of the map composable */
  val farRight: Position,
  /** Position corresponding to the bottom-left corner of the map composable */
  val nearLeft: Position,
  /** Position corresponding to the bottom-right corner of the map composable */
  val nearRight: Position,
)
